export default __webpack_public_path__ + "static/media/blogimg3.e08c8f25.jpg";